import {
  components,
  useTranslation
} from 'cng-web-lib'

import AccessLevelUserRuleFormProperties from './AccessLevelUserRuleFormProperties'
import AccessLevelUserRuleApiUrls from 'src/apiUrls/AccessLevelUserRuleApiUrls'
import React from 'react'
import Namespace from 'src/constants/locale/Namespace'
import AccessLevelUserKeys from 'src/constants/locale/key/AccessLevelUser'


const {
  table: {
    CngServerModeDialogFormTable,
    useFetchCustomLookup,
  }
} = components


function AccessLevelUserRuleCrudTable({
  showNotification,
  accessLevelUserId,
  isViewOnly = false
}) {
  const { translate } = useTranslation([Namespace.ACCESS_LEVEL_USER])
  const translatedTextsObject = makeTranslatedTextsObject();
  const fetchCustomLookup = useFetchCustomLookup();

  let create = { url: AccessLevelUserRuleApiUrls.POST }
  let update = { url: AccessLevelUserRuleApiUrls.PUT }
  let del = { url: AccessLevelUserRuleApiUrls.DELETE }
  if (isViewOnly) {
    create = undefined
    update = undefined
    del = undefined
  }

  function makeTranslatedTextsObject() {
    let companyCustomRuleId = translate(
      Namespace.ACCESS_LEVEL_USER,
      AccessLevelUserKeys.AccessLevelUserRule.COMPANY_CUSTOM_RULE_ID
    )

    return {
      companyCustomRuleId
    }
  }

  const columns = [
    {
      field: 'companyCustomRuleId',
      title: translatedTextsObject.companyCustomRuleId,
      customLookup: () => {
        return fetchCustomLookup(
          `${process.env.REACT_APP_COMMON_SERVICE_ORIGIN_URL}/account-setup/access-level-rule/hdr/getByParty`,
          { },
          'content',
          'name',
          'id',
          (error) => console.error(error)
        )
      }
    }
  ]

  return (
    <CngServerModeDialogFormTable
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      disabled={isViewOnly}
      showNotification={showNotification}
      tableColumns={columns}
      formProperties={{
        ...AccessLevelUserRuleFormProperties,
        formikProps: {
          ...AccessLevelUserRuleFormProperties.formikProps,
          initialValues: {
            ...AccessLevelUserRuleFormProperties.formikProps.initialValues,
            accessLevelUserId: accessLevelUserId
          }
        }
      }}
      toClientDataFormat={(serverData) => {
        return serverData;
      }}
      toServerDataFormat={(localDatum) => {
        return localDatum;
      }}
      fetch={{
        url: AccessLevelUserRuleApiUrls.GET,
        body: {
          accessLevelUserId: accessLevelUserId
        }
      }}
      create={create}
      update={update}
      del={del}
      idAccessor='id'
    // tableConfigurationCode=''
    />
  )
}

export default AccessLevelUserRuleCrudTable
